import { Formation } from "../types"

export const pos65for: Formation = {
  id: "pos65for",
  name: "6 - 5",
  category: "6 - 5",
  snapshots: [
    {
      players: [
        {
          x: 4.862418463010799,
          y: 6.351510871695789
        },
        {
          x: 9.324932905080926,
          y: 5.8963166559326465
        },
        {
          x: 12.627589509478607,
          y: 3.1026079002389486
        },
        {
          x: 8.952938959447572,
          y: 2.839811190624533
        },
        {
          x: 5.456149940992057,
          y: 3.0311407273815525
        },
        {
          x: 1.4004834903183805,
          y: 2.809795858184924
        }
      ],
      opponents: [
        {
          x: 8.40038008786729,
          y: 4.259195817698999
        },
        {
          x: 10.802912667660731,
          y: 2.5602350269167227
        },
        {
          x: 7.099779628083698,
          y: 3.1199817725834453
        },
        {
          x: 5.447166105609925,
          y: 4.607182146115685
        },
        {
          x: 4.4284116318861075,
          y: 3.076199366342779
        }
      ],
      ball: {
        x: 8.917688531545187,
        y: 6.576890842888945
      },
      goalkeepers: [
        {
          x: 7.065939316470421,
          y: 0.6706103982321535
        }
      ]
    }
  ]
}
